// import { Select } from "antd";
import "./Layout.scss";
import { navBarItems } from "../constants/appConstats";
import {
  bookLabel,
  languageOptions,
  navBarLabels,
} from "../constants/translations";
import { useLocation, useNavigate } from "react-router-dom";
import { Logo } from "../assets/photos";
import { PrimaryButton } from "../components/PrimaryButton";
import { useMemo } from "react";
import { scrollToSection } from "../hooks/ScrollToSection";

export const Header = ({ languageId, setLanguageId }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const path =
    location.pathname === "/tour-intenerary"
      ? "/tours-experiences"
      : location.pathname;

  const goToHome = () => {
    navigate("/");
  };

  const isMobile = useMemo(() => window.innerWidth <= 768, []); // Adjust the breakpoint as needed

  return isMobile ? (
    <header className="app-header">
      <div className="header__mobile">
        <div className="firstColumn">
          <div className="header__logo" onClick={goToHome}>
            <img
              src={Logo}
              width={"100%"}
              height={"100%"}
              alt="ShkodraTour Logo"
            />
          </div>

          <div className="header__actions">
            {/* <Select
              className="header__lang"
              defaultValue="EN"
              options={languageOptions}
              onChange={(e) => {
                setLanguageId(e);
              }}
            /> */}
            <nav className="header__nav" aria-label="Main navigation">
              {navBarItems.map((item) => (
                <a
                  key={item.key}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(item.path);
                  }}
                  className={path === item.path ? "active" : ""}
                >
                  {navBarLabels[languageId].labels[item?.key - 1] || item.label}
                </a>
              ))}
            </nav>
          </div>
        </div>
      </div>
    </header>
  ) : (
    <header className="app-header">
      <div className="header__logo" onClick={goToHome}>
        <img src={Logo} width={"100%"} height={"100%"} alt="ShkodraTour Logo" />
      </div>

      <nav className="header__nav" aria-label="Main navigation">
        {navBarItems.map((item) => (
          <a
            key={item.key}
            onClick={(e) => {
              e.preventDefault();
              navigate(item.path);
            }}
            className={path === item.path ? "active" : ""}
          >
            {navBarLabels[languageId].labels[item?.key - 1] || item.label}
          </a>
        ))}
      </nav>

      <div className="header__actions">
        {/* <Select
          className="header__lang"
          defaultValue="EN"
          options={languageOptions}
          onChange={(e) => {
            setLanguageId(e);
          }}
        /> */}
        {path === "/" && (
          <PrimaryButton
            label={bookLabel[languageId]?.label}
            type="primary"
            onClick={() => scrollToSection("packages")}
          />
        )}
      </div>
    </header>
  );
};
